(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name message.controller:MultipleAlertSendPopUpCtrl
	 *
	 * @description
	 *
	 */
	angular.module('message').controller('MultipleAlertSendPopUpCtrl',
			MultipleAlertSendPopUpCtrl);

	function MultipleAlertSendPopUpCtrl(AlertManagerService, $uibModalInstance,
			modalParams) {

		var vm = this;
		vm.ctrlName = 'multipleAlertSendCtrl';

		vm.model = {
			alerts : modalParams,
			smsToSend : AlertManagerService.getSMSSendRequest(),
			selectedAlerts : [],
			maxCharactersInMSG : 0,
      isSendClicked:false
		};
		getMaxCharCountInSentMsg();

		//when close the pop up
		vm.onCloseClick = function() {
			$uibModalInstance.close('CLOSE');
		};

		function setSelectedAlerts(){
			vm.model.selectedAlerts = [];
			if(!!vm.model.alerts && vm.model.alerts.length>0){
				for(var i=0;i<vm.model.alerts.length;i++){
					if(!!vm.model.alerts[i].crewName && !!vm.model.alerts[i].crewName!=null){
						vm.model.selectedAlerts.push(vm.model.alerts[i]);
					}
				}
			}
		};

		vm.onSendSMS = function() {
      vm.model.isSendClicked = true;
			setSelectedAlerts();
			vm.model.smsToSend.crewProfileIdList = vm.model.selectedAlerts.length>0? AlertManagerService
			.setSMSRequestInMultiSelect(vm.model.selectedAlerts).crewProfileIdList : [];
			if(!!vm.model.smsToSend.content && vm.model.smsToSend.content.trim()!=''){
				$uibModalInstance.close(vm.model.smsToSend);
			}
		};

		function getMaxCharCountInSentMsg() {
			AlertManagerService
					.getSendMsgMaxCharacterCount(
							function(charCount) {
								vm.model.maxCharactersInMSG = charCount === null ? 0
										: charCount.paramValue;
							},
							function() {
								console
										.log('App Param Send Msg Character Count retrieval error');
							});
		};
	}
}());
